import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "bonusomat-quest__image-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "bonusomat-quest__details" }
const _hoisted_5 = { class: "bonusomat-quest__details-item bonusomat-quest__details-item--yellow" }
const _hoisted_6 = { class: "bonusomat-quest__award-text" }
const _hoisted_7 = { class: "bonusomat-quest__details-items-group" }
const _hoisted_8 = { class: "bonusomat-quest__details-item" }
const _hoisted_9 = {
  key: 0,
  class: "bonusomat-quest__details-item"
}
const _hoisted_10 = { class: "bonusomat-quest__tasks" }
const _hoisted_11 = {
  key: 1,
  class: "bonusomat-quest__no-tasks-box"
}
const _hoisted_12 = { class: "bonusomat-modal__footer__progress-wrapper" }
const _hoisted_13 = { class: "bonusomat-modal__footer__texts" }
const _hoisted_14 = { class: "bonusomat-modal__footer__state" }
const _hoisted_15 = {
  key: 0,
  class: "bonusomat-modal__footer__remaining-tasks"
}
const _hoisted_16 = { class: "bonusomat-modal__footer__tasks-count" }
const _hoisted_17 = {
  key: 0,
  class: "bonusomat-modal__footer__reward"
}
const _hoisted_18 = { class: "bonusomat-quest__award-text" }

import { computed, onMounted, ref } from "vue";
import DsBadge from "@sazka/design-system/src/badge/ds-badge.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsDivider from "@sazka/design-system/src/divider/ds-divider.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import ModalHeadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import { SvgIcons } from "@sazka/design-system/src/icon/types";
import { DsModalDialogReferenceType } from "@sazka/design-system/src/modal-dialog/ds-modal-dialog-models";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatQuestAwardIcon from "./bonusomat-quest-award-icon.vue";
import QuestAccordion from "./bonusomat-quest-detail-accordion.vue";
import QuestDetailGames from "./bonusomat-quest-detail-games.vue";
import useBonusomatData from "../../composables/use-bonusomat-data";
import { useQuestDetails } from "../../composables/use-quest-details";
import { BonusomatQuestTask } from "../../models/bonusomat-quest-detail";
import { BonusomatUtils } from "../../utils/bonusomat-utils";
import BonusomatProgress from "../shared/bonusomat-progress.vue";

const gamesSectionHeadline = "Úkol splníte hraním vybraných her";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quest-detail',
  setup(__props) {

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const {
    isQuestModalOpen,
    openedQuest,
    questCardProgressLoadCounter,
    questDetailProgressLoadCounter,
    gamesData,
    openedGamesTaskIndex,
    activateQuest,
    deactivateQuest,
    loadGamesData,
} = useBonusomatData();

const { isActive, isCompleted, isBonusAward, remainingTasks, questTimeLabel, questProgress, isPlayable } =
    useQuestDetails(openedQuest);

const questModalRef = ref<DsModalDialogReferenceType>();
const areTasksGamesOpened = ref(false);

const questProgressKey = computed(() => {
    return "questDetailProgress-" + questDetailProgressLoadCounter.value;
});

const sortedTasks = computed(() => {
    return openedQuest.value.tasks
        ?.slice()
        .sort((a, b) => (a.progress < 100 && b.progress >= 100 ? -1 : a.progress >= 100 && b.progress < 100 ? 1 : 0));
});

const completedQuestRewardInfoClass = computed(() => {
    return openedQuest.value.award.length > 16 ? "bonusomat-quest__details-item--long-text" : "";
});

const hasAnyTask = computed(() => {
    return !!openedQuest.value.tasks?.length;
});

const totalTasksFormatted = computed(() => {
    return openedQuest.value ? BonusomatUtils.getTaskCountLabel(openedQuest.value.totalTasks) : "";
});

const remainingTasksFormatted = computed(() => {
    return openedQuest.value ? BonusomatUtils.getTaskCountLabel(remainingTasks.value) : "";
});

const footerQuestState = computed(() => {
    if (isActive.value) {
        return "Aktivní";
    } else if (isCompleted.value) {
        return "Dokončeno";
    } else {
        return "Neaktivní";
    }
});

const remainingInclined = computed(() => {
    switch (remainingTasks.value) {
        case 2:
        case 3:
        case 4:
            return "Zbývají";
        default:
            return "Zbývá";
    }
});

const footerButtonText = computed(() => {
    if (isCompleted.value) {
        return isBonusAward.value ? "Zobrazit výhru" : "Zavřít";
    } else if (isActive.value) {
        return "Deaktivovat";
    } else if (!hasAnyTask.value) {
        return "Získat bonus";
    } else {
        return "Začít hrát";
    }
});

const footerButtonType = computed(() => {
    if (isActive.value) {
        return "error";
    } else if (isCompleted.value && !isBonusAward.value) {
        return "secondary";
    } else {
        return "primary";
    }
});

const footerButtonIcon = computed<SvgIcons>(() => {
    if (isActive.value) {
        return "cross";
    } else {
        return null;
    }
});

const openedGamesTask = ref<BonusomatQuestTask>(null);

const showGamesForTask = async (taskToShowGames: BonusomatQuestTask, taskIndex: number) => {
    if (!gamesData.value?.length) {
        await loadGamesData();
    }
    questDetailProgressLoadCounter.value++;

    openedGamesTask.value = taskToShowGames;
    openedGamesTaskIndex.value = taskIndex;
    areTasksGamesOpened.value = true;
    questModalRef.value.scrollContent();
};

const goBackToTasks = () => {
    if (areTasksGamesOpened.value) {
        BonusomatDatalayer.pushCloseQuestGames(openedGamesTask.value?.title);
    }
    questDetailProgressLoadCounter.value++;

    areTasksGamesOpened.value = false;
    openedGamesTask.value = null;
};

const closeModalAndGoBackToTasks = () => {
    isQuestModalOpen.value = false;
    goBackToTasks();
};

const footerButtonClickHandler = async () => {
    const executedFromGamesSection = areTasksGamesOpened.value;

    if (isCompleted.value) {
        closeModalAndGoBackToTasks();

        if (!isBonusAward.value) {
            return;
        }

        ng_fw.showMyBonuses();

        BonusomatDatalayer.pushShowWinnings(openedQuest.value.title);
    } else if (isActive.value) {
        closeModalAndGoBackToTasks();

        try {
            await deactivateQuest(executedFromGamesSection ? "questDetailGames" : "questDetail");
        } catch (ex: unknown) {
            console.error(ex);
        }
    } else {
        try {
            await activateQuest(openedQuest.value.id);
        } finally {
            BonusomatDatalayer.pushStartQuest(
                openedQuest.value.title,
                "questDetail",
                bonusomatPlayerData.value.points,
                remainingSpinsCount.value
            );
            setTimeout(() => {
                questCardProgressLoadCounter.value++;
            }, 300);
        }
    }
};

const scrollTaskIntoView = ref(false);
onMounted(() => {
    scrollTaskIntoView.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: _unref(isQuestModalOpen),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isQuestModalOpen) ? (isQuestModalOpen).value = $event : null)),
    theme: "dark",
    "css-class": [
            'bonusomat-modal',
            'bonusomat-modal--wider',
            areTasksGamesOpened.value ? 'bonusomat-quest-games' : 'bonusomat-quest',
        ],
    "top-divider-visible": true,
    "bottom-divider-visible": false,
    "content-scrollable": true,
    "has-dialog-close-btn": !areTasksGamesOpened.value,
    onModalClosed: _cache[3] || (_cache[3] = ($event: any) => (closeModalAndGoBackToTasks())),
    ref_key: "questModalRef",
    ref: questModalRef
  }, _createSlots({
    bottom: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["bonusomat-modal__footer", {
                    'bonusomat-modal__footer--completed': _unref(isCompleted),
                    'bonusomat-modal__footer--active': _unref(isActive),
                }])
      }, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(), _createBlock(BonusomatProgress, {
            key: questProgressKey.value,
            progress: _unref(questProgress),
            "is-completed": _unref(openedQuest).completed,
            "show-tracker-even-if-completed": true,
            "show-percentage-number": ""
          }, null, 8, ["progress", "is-completed"])),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(footerQuestState.value), 1),
            (!_unref(isCompleted) && hasAnyTask.value && _unref(remainingTasks))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(remainingInclined.value), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(remainingTasksFormatted.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_unref(isCompleted))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _cache[5] || (_cache[5] = _createTextVNode(" Vaše výhra ")),
              _createElementVNode("div", {
                class: _normalizeClass(["bonusomat-quest__details-item bonusomat-quest__details-item--yellow", completedQuestRewardInfoClass.value])
              }, [
                _createVNode(BonusomatQuestAwardIcon, {
                  "icon-name": _unref(openedQuest).awardIcon
                }, null, 8, ["icon-name"]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(openedQuest).award), 1)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createVNode(DsButton, {
          theme: "dark",
          size: "lg",
          type: footerButtonType.value,
          "icon-left": footerButtonIcon.value,
          "is-disabled": !_unref(isPlayable),
          onClick: footerButtonClickHandler
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(footerButtonText.value), 1)
          ]),
          _: 1
        }, 8, ["type", "icon-left", "is-disabled"])
      ], 2)
    ]),
    _: 2
  }, [
    (areTasksGamesOpened.value)
      ? {
          name: "top",
          fn: _withCtx(() => [
            _createVNode(DsButton, {
              "icon-left": "arrow-left",
              theme: "dark",
              type: "interaction",
              size: "lg",
              onClick: goBackToTasks,
              class: "bonusomat-quest__games-back-btn"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Zpět ")
              ])),
              _: 1,
              __: [4]
            }),
            _createVNode(ModalHeadline, {
              headline: gamesSectionHeadline,
              class: "bonusomat-quest__bonusomat-quest__games-modal-title"
            }),
            _createElementVNode("div", {
              class: "bonusomat-modal__games-modal-description",
              innerHTML: openedGamesTask.value.description
            }, null, 8, _hoisted_1)
          ]),
          key: "0"
        }
      : {
          name: "top",
          fn: _withCtx(() => [
            _createVNode(ModalHeadline, {
              headline: _unref(openedQuest)?.title,
              class: "bonusomat-quest__title"
            }, null, 8, ["headline"])
          ]),
          key: "1"
        },
    (areTasksGamesOpened.value)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createVNode(QuestDetailGames, {
              task: openedGamesTask.value,
              "quest-name": _unref(openedQuest)?.title,
              onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (closeModalAndGoBackToTasks()))
            }, null, 8, ["task", "quest-name"])
          ]),
          key: "2"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_unref(openedQuest).badge)
                ? (_openBlock(), _createBlock(DsBadge, {
                    key: 0,
                    text: _unref(openedQuest).badge,
                    class: "bonusomat-quest__badge"
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true),
              _createVNode(WebpImage, {
                src: _unref(openedQuest).image,
                alt: "",
                "css-class": "bonusomat-quest__image"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("p", {
              class: "bonusomat-modal__description",
              innerHTML: _unref(openedQuest).description
            }, null, 8, _hoisted_3),
            _createVNode(DsDivider, { theme: "dark" }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(BonusomatQuestAwardIcon, {
                  "icon-name": _unref(openedQuest).awardIcon
                }, null, 8, ["icon-name"]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(openedQuest).award), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(DsIcon, {
                    name: "bet-list",
                    width: 24,
                    height: 24
                  }),
                  _createTextVNode(" " + _toDisplayString(totalTasksFormatted.value), 1)
                ]),
                (_unref(openedQuest).endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(DsIcon, {
                        name: "time",
                        width: 24,
                        height: 24
                      }),
                      _createTextVNode(" " + _toDisplayString(_unref(questTimeLabel)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              (hasAnyTask.value)
                ? (_openBlock(), _createBlock(QuestAccordion, {
                    key: 0,
                    tasks: sortedTasks.value,
                    "default-open-task-index": _unref(openedGamesTaskIndex),
                    theme: "dark",
                    onShowTaskGames: _cache[1] || (_cache[1] = (taskToShowGames, taskIndex) =>
                showGamesForTask(taskToShowGames, taskIndex)),
                    scrollTaskIntoView: scrollTaskIntoView.value
                  }, null, 8, ["tasks", "default-open-task-index", "scrollTaskIntoView"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, "Žádné úkoly k plnění"))
            ])
          ]),
          key: "3"
        }
  ]), 1032, ["modelValue", "css-class", "has-dialog-close-btn"]))
}
}

})